export default __webpack_public_path__ + "static/media/nodejs.f22eb213.svg";